export default () => {
  const zoom = {
    width: {
      default: 1440,
      min: 1000,
      max: 1920,
    },
    height: {
      default: 850,
      min: 600,
      max: 1100,
    },
    scale: {
      x: 1,
      y: 1,
      xy: 1,
    },
    ratio: {
      width: 1,
      height: 1,
    },
    window: {
      width: 0,
      height: 0,
    },
  };

  if (window.innerWidth <= 1280 && window.innerHeight <= 800) {
    zoom.ratio.width = 0.9;
    zoom.ratio.height = 0.95;
  } else {
    zoom.ratio.width = 1;
    zoom.ratio.height = 1;
  }

  const minWidth = (zoom.width.min / zoom.width.default) * zoom.ratio.width;
  const maxWidth = (zoom.width.max / zoom.width.default) * zoom.ratio.width;
  const minHeight = (zoom.height.min / zoom.height.default) * zoom.ratio.height;
  const maxHeight = (zoom.height.max / zoom.height.default) * zoom.ratio.height;

  zoom.scale.x = (window.innerWidth / zoom.width.default) * zoom.ratio.width;
  zoom.scale.y = (window.innerHeight / zoom.height.default) * zoom.ratio.height;

  if (zoom.scale.x < minWidth) {
    zoom.scale.x = minWidth;
  }
  if (zoom.scale.x > maxWidth) {
    zoom.scale.x = maxWidth;
  }
  if (zoom.scale.y < minHeight) {
    zoom.scale.y = minHeight;
  }
  if (zoom.scale.y > maxHeight) {
    zoom.scale.y = maxHeight;
  }

  if (zoom.scale.x < zoom.scale.y) {
    zoom.scale.xy = zoom.scale.x;
  } else {
    zoom.scale.xy = zoom.scale.y;
  }

  // return 1;
  return zoom.scale.xy;
};



// WEBPACK FOOTER //
// ./src/components/zoom.js